import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import useCurrentUser from "APP_ROOT/hooks/useCurrentUser";
import { STORE_LOCATION_ID } from "MODULES/inventories/constants";
import { ID } from "APP_ROOT/constants";
import Form from "./Form";

export default function Transfer({ editing, close, inventory }) {
  const currentUser = useCurrentUser();
  const locations = currentUser.locations
    .filter(l => l.id !== inventory.get(STORE_LOCATION_ID))
    .map(l => ({
      text: l.name,
      value: l.id
    }));

  const initialValues = {
    id: inventory.get(ID),
    transfer_to_location_id: locations[0].value
  };

  return (
    <Modal
      key={inventory.get(ID)}
      open={editing}
      close={close}
      dialogClass="modal-sm"
    >
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Transfer Inventory</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        enableReinitialize
        locations={locations}
      />
    </Modal>
  );
}

Transfer.propTypes = {
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  inventory: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/Transfer/Transfer.jsx